import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { injectIntl, FormattedMessage } from 'react-intl';
import './DesktopMenu.css';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IDesktopMenuItemProps {
  intl: any;
  text: string;
  clickMe?: any;
  disabled?: boolean;
  img: IconProp;
}

const DesktopMenuItem = (props: IDesktopMenuItemProps) => {

  const classes = ['DesktopMenuItem', 'Button-Label'];
  if (props.disabled) {
      classes.push('disabled');
  }
  return (
    <button className="DesktopMenuItem Button-Label d-flex flex-column" onClick={() => props.clickMe()} disabled={props.disabled}>
      <FontAwesomeIcon className="Menu-Icon" size="lg" icon={props.img}/>
      <span><FormattedMessage  id={props.text} /></span>
    </button>
  );

};

export default injectIntl(DesktopMenuItem);
